import { Select, Tooltip } from "antd";
import React from "react";
import { useNotification } from "../../../contexts/Notifications";
import { useGetAllSpaceCategoriesQuery } from "../../../generated/types";
import { Project } from "../../../types";
import styles from "../selectorStyles.module.css";
import { CATEGORIES_LOADING_ERROR } from "./messages";

type SpaceCategorySelectorProps = {
  selectedCategories: string[];
  project: Project;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string[]) => void;
  allowCreatingNewValue?: boolean;
};

export const SpaceCategorySelector = (props: SpaceCategorySelectorProps) => {
  const {
    data: allCategoryTags,
    error,
    loading,
  } = useGetAllSpaceCategoriesQuery({
    variables: {
      customer: props.project.customer,
      project: props.project.project,
      scope: props.project.scope,
    },
  });
  const notify = useNotification();

  if (error) {
    notify(CATEGORIES_LOADING_ERROR, "error");
  }

  return (
    <Select
      allowClear
      disabled={props.disabled || !!error}
      loading={loading}
      className={styles.selector}
      value={props.selectedCategories}
      mode={props.allowCreatingNewValue ? "tags" : "multiple"}
      placeholder={props.placeholder ?? "Select..."}
      onChange={props.onChange}
    >
      {allCategoryTags?.spaceCategories.map((tag) => (
        <Select.Option key={tag} value={tag}>
          <Tooltip title={tag}>{tag}</Tooltip>
        </Select.Option>
      ))}
    </Select>
  );
};
